// export const ADMIN_URL = 'http://192.168.1.203/ethereal/admin/'
// export const ADMIN_URL = 'https://projects.enlivendc.com/ethereal/dev/admin/'
// export const ADMIN_URL = 'https://cometlabs.app/ethereal/dev/admin/'
// export const ADMIN_URL = 'https://ethereal.himyeti.com/admin/'
// export const ADMIN_URL = 'https://enlivendcbeta.online/admin/'
// export const ADMIN_URL = 'https://enlivendcbeta.online/admin/'
export const ADMIN_URL = 'https://etherealdiamond.enlivendc.com/'